// ISO 3166-1 alpha-2 codes for flag images, keyed by the country names the API and coverage data use.
// Pages prefer the record's own country_code; this map covers records and routes that only carry a name.
export const FLAG_CODES = {
  'Albania': 'al',
  'Angola': 'ao',
  'Anguilla': 'ai',
  'Antigua': 'ag',
  'Antigua And Barbuda': 'ag',
  'Antigua and Barbuda': 'ag',
  'Argentina': 'ar',
  'Australia': 'au',
  'Austria': 'at',
  'Azerbaijan': 'az',
  'Bahamas': 'bs',
  'Bahrain': 'bh',
  'Bangladesh': 'bd',
  'Barbados': 'bb',
  'Belarus': 'by',
  'Belgium': 'be',
  'Belize': 'bz',
  'Benin': 'bj',
  'Bermuda': 'bm',
  'Bolivia': 'bo',
  'Bonaire': 'bq',
  'Bosnia': 'ba',
  'Bosnia & Herzegovina': 'ba',
  'Bosnia-Herzegovina': 'ba',
  'St. Vincent & Grenadines': 'vc',
  'Saba': 'bq',
  'Saba - Mobile': 'bq',
  'St. Eustatius': 'bq',
  'St. Eustatius - Mobile': 'bq',
  'Bosnia and Herzegovina': 'ba',
  'Botswana': 'bw',
  'Brazil': 'br',
  'British Virgin Islands': 'vg',
  'Brunei': 'bn',
  'Bulgaria': 'bg',
  'Burkina Faso': 'bf',
  'Camaroon': 'cm',
  'Cambodia': 'kh',
  'Cameroon': 'cm',
  'Canada': 'ca',
  'Cayman': 'ky',
  'Cayman Islands': 'ky',
  'Chile': 'cl',
  'China': 'cn',
  'Colombia': 'co',
  'Congo DR': 'cd',
  'Costa Rica': 'cr',
  "Cote d'Ivoire": 'ci',
  'Croatia': 'hr',
  'Cuba': 'cu',
  'Curacao': 'cw',
  'Curaçao': 'cw',
  'Cyprus': 'cy',
  'Czech Republic': 'cz',
  'Czechia': 'cz',
  'Denmark': 'dk',
  'Dominica': 'dm',
  'Dominican Rep.': 'do',
  'Dominican Republic': 'do',
  'Ecuador': 'ec',
  'Egypt': 'eg',
  'El Salvador': 'sv',
  'Estonia': 'ee',
  'Eswatini': 'sz',
  'Ethiopia': 'et',
  'Fiji': 'fj',
  'Finland': 'fi',
  'France': 'fr',
  'French Guiana': 'gf',
  'Georgia': 'ge',
  'Germany': 'de',
  'Ghana': 'gh',
  'Greece': 'gr',
  'Grenada': 'gd',
  'Guadeloupe': 'gp',
  'Guam': 'gu',
  'Guatemala': 'gt',
  'Honduras': 'hn',
  'Hong Kong': 'hk',
  'Hungary': 'hu',
  'Iceland': 'is',
  'India': 'in',
  'India + CLI': 'in',
  'Indonesia': 'id',
  'Ireland': 'ie',
  'Israel': 'il',
  'Italy': 'it',
  'Ivory Coast': 'ci',
  'Jamaica': 'jm',
  'Japan': 'jp',
  'Jordan': 'jo',
  'Kazakhstan': 'kz',
  'Kenya': 'ke',
  'Kosovo': 'xk',
  'Kuwait': 'kw',
  'Kyrgyzstan': 'kg',
  'Laos': 'la',
  'Latvia': 'lv',
  'Liberia': 'lr',
  'Lithuania': 'lt',
  'Luxembourg': 'lu',
  'Macao': 'mo',
  'Macau': 'mo',
  'Macedonia': 'mk',
  'Malawi': 'mw',
  'Malaysia': 'my',
  'Malta': 'mt',
  'Martinique': 'mq',
  'Mauritius': 'mu',
  'Mayotte': 'yt',
  'Mexico': 'mx',
  'Moldova': 'md',
  'Monaco': 'mc',
  'Montenegro': 'me',
  'Montserrat': 'ms',
  'Morocco': 'ma',
  'Mozambique': 'mz',
  'Myanmar': 'mm',
  'Namibia': 'na',
  'Nepal': 'np',
  'Netherlands': 'nl',
  'New Zealand': 'nz',
  'Nicaragua': 'ni',
  'Nicaraqua': 'ni',
  'Nigeria': 'ng',
  'North Macedonia': 'mk',
  'Norway': 'no',
  'Oman': 'om',
  'Pakistan': 'pk',
  'Panama': 'pa',
  'Papua New Guinea': 'pg',
  'Paraguay': 'py',
  'Peru': 'pe',
  'Philippines': 'ph',
  'Poland': 'pl',
  'Portugal': 'pt',
  'Puerto Rico': 'pr',
  'Qatar': 'qa',
  'Reunion': 're',
  'Romania': 'ro',
  'Russia': 'ru',
  'Saba': 'bq',
  'Saint Kitts and Nevis': 'kn',
  'Saint Lucia': 'lc',
  'Saint Pierre And Miquelon': 'pm',
  'Saint Pierre and Miquelon': 'pm',
  'Saint Vincent and the Grenadines': 'vc',
  'Saudi Arabia': 'sa',
  'Serbia': 'rs',
  'Seychelles': 'sc',
  'Singapore': 'sg',
  'Slovakia': 'sk',
  'Slovenia': 'si',
  'South Africa': 'za',
  'South Korea': 'kr',
  'Spain': 'es',
  'Sri Lanka': 'lk',
  'St. Eustatius': 'bq',
  'St. Maarten': 'sx',
  'Sint Eustatius': 'bq',
  'Sint Maarten': 'sx',
  'Sweden': 'se',
  'Switzerland': 'ch',
  'Taiwan': 'tw',
  'Tanzania': 'tz',
  'Thailand': 'th',
  'Trinidad and Tobago': 'tt',
  'Tunisia': 'tn',
  'Turkey': 'tr',
  'Turks and Caicos': 'tc',
  'Turks and Caicos Islands': 'tc',
  'Türkiye': 'tr',
  'UAE': 'ae',
  'Uganda': 'ug',
  'UK': 'gb',
  'Ukraine': 'ua',
  'United Arab Emirates': 'ae',
  'United Kingdom': 'gb',
  'United States': 'us',
  'United States Virgin Islands': 'vi',
  'Uruguay': 'uy',
  'Uruquay': 'uy',
  'USA': 'us',
  'Uzbekistan': 'uz',
  'Venezuela': 've',
  'Vietnam': 'vn',
  'Zambia': 'zm',
  'Zimbabwe': 'zw',
};

/** Flag code for a country record ({ country_code | countryCode | country | name }) or a plain name. */
// Same name written differently ("Antigua & Barbuda", "ST. LUCIA"): compare lower-case, "&" as "and", no dots.
const loose = (n) => n.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/&/g, 'and').replace(/[.']/g, '').replace(/\s+/g, ' ').trim();
let LOOSE = null;
const looseCode = (name) => {
  if (!LOOSE) LOOSE = Object.fromEntries(Object.entries(FLAG_CODES).map(([k, v]) => [loose(k), v]));
  return LOOSE[loose(name)] || LOOSE[loose(name).replace(/^st /, 'saint ')] || null;
};

export const flagCode = (c) => {
  if (!c) return null;
  if (typeof c === 'string') return FLAG_CODES[c] || FLAG_CODES[c.normalize('NFD').replace(/[\u0300-\u036f]/g, '')] || looseCode(c);
  return c.country_code || c.countryCode || FLAG_CODES[c.country] || FLAG_CODES[c.name] || null;
};

/** flagcdn.com image URL for a country, or null when no code is known. */
export const flagUrl = (c, width = 40) => {
  const code = flagCode(c);
  return code ? `https://flagcdn.com/w${width}/${code.toLowerCase()}.png` : null;
};
